import React, { useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';

const SANITIZE_OPTIONS = {
  RETURN_DOM_FRAGMENT: true,
  FORBID_TAGS: ['iframe', 'frame', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button', 'style', 'script'],
};

// Renders admin-authored HTML after sanitizing it into DOM nodes (no raw HTML injection).
export function SafeHtml({ html, className, testId }) {
  const ref = useRef(null);

  useEffect(() => {
    ref.current.replaceChildren(DOMPurify.sanitize(html || '', SANITIZE_OPTIONS));
  }, [html]);

  return <div ref={ref} className={className} data-testid={testId} />;
}
